import membersAPI from '../../../api/members'

const mapOrder = (order) => {
  switch (order) {
  case 'user':
    return 'name'
  case 'joined':
    return 'tenant_users.created_at'
  default:
    return 'name'
  }
}

export default {
  async index({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta

    const params = {tenantID}

    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await membersAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id}) {
    const tenantID = rootState.tenants.current.id
    const resp = await membersAPI.show({tenantID, memberID: id})
    const member = resp.data.data
    commit('setCurrent', member)
  },

  async store({commit, state, rootState, dispatch}) {
    const tenantID = rootState.tenants.current.id

    const data = {
      email: state.forms.store.fields.email,
      role: state.forms.store.fields.role
    }

    // add any module relations
    let moduleData
    if (state.forms.relateModules.fields.moduleIDs !== null) {
      moduleData = {'modules': state.forms.relateModules.fields.moduleIDs}
    }

    // add any group relations
    let groupData
    if (state.forms.relateGroups.fields.groupIDs !== null) {
      groupData = {'groups': state.forms.relateGroups.fields.groupIDs}
    }

    let newMember, resp
    let addedRelations = false
    let success = true

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/store/setSaving', true)

    try {
      // store the member
      resp = await membersAPI.store({tenantID, data})
      newMember = resp.data.data

      // add any module relations
      if (moduleData) {
        await membersAPI.relateModules({tenantID, memberID: newMember.id, data: moduleData})
        addedRelations = true
      }

      // add any group relations
      if (groupData) {
        await membersAPI.relateGroups({tenantID, memberID: newMember.id, data: groupData})
        addedRelations = true
      }

      // update the resource if we added any relations
      if (addedRelations) {
        resp = await membersAPI.show({tenantID, memberID: newMember.id})
        newMember = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSuccess', success)
    commit('forms/store/setSaving', false)

    if (success) {
      commit('setCurrent', newMember)
      dispatch('index', state._defaultView)
    }
  },

  async update({commit, state, rootState, dispatch}, {memberID}) {
    const tenantID = rootState.tenants.current.id

    const data = {}
    if (state.forms.update.fields.role) {
      data.role = state.forms.update.fields.role
    }

    if (state.forms.update.fields.active) {
      data['is_active'] = state.forms.update.fields.active
    }

    // add any module relations
    let moduleData
    if (state.forms.relateModules.fields.moduleIDs !== null) {
      moduleData = {'modules': state.forms.relateModules.fields.moduleIDs}
    }

    // add any group relations
    let groupData
    if (state.forms.relateGroups.fields.groupIDs !== null) {
      groupData = {'groups': state.forms.relateGroups.fields.groupIDs}
    }

    let success = true
    let addedRelations = false
    let updatedMember, resp

    commit('forms/update/resetErrors')
    commit('forms/update/resetSuccess')
    commit('forms/update/setSaving', true)

    try {
      // update the member
      resp = await membersAPI.update({tenantID, memberID, data})
      updatedMember = resp.data.data

      // add any module relations
      if (moduleData) {
        await membersAPI.relateModules({tenantID, memberID: updatedMember.id, data: moduleData})
        addedRelations = true
      }

      // add any group relations
      if (groupData) {
        await membersAPI.relateGroups({tenantID, memberID: updatedMember.id, data: groupData})
        addedRelations = true
      }

      // update the resource if we added any relations
      if (addedRelations) {
        resp = await membersAPI.show({tenantID, memberID: updatedMember.id})
        updatedMember = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/update/setErrors', errors)
        }
      }
    }

    commit('forms/update/setSuccess', success)
    commit('forms/update/setSaving', false)

    if (success) {
      commit('setCurrent', updatedMember)
      dispatch('index', state._defaultView)
    }

  },

  async restore({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const data = { 'is_deleted': false, 'is_active': true }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await membersAPI.update({tenantID, memberID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async archive({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await membersAPI.destroy({tenantID, memberID: id})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/members/actions.js